import React from 'react';
import PropTypes from 'prop-types';

export const FlipButton = ({ onClick = () => {} }) => (
  <>
    <path
      d="M322.22 26.4666C322.601 20.8425 327.131 16.4493 332.761 16.1616C334.629 16.0661 336.511 16 338.142 16C339.683 16 341.45 16.0591 343.218 16.1463C348.985 16.4307 353.568 21.0229 353.851 26.7903C353.939 28.6031 354 30.419 354 32C354 33.581 353.939 35.3969 353.851 37.2097C353.568 42.9771 348.985 47.5693 343.218 47.8537C341.45 47.9409 339.683 48 338.142 48C336.511 48 334.629 47.9339 332.761 47.8384C327.131 47.5507 322.601 43.1575 322.22 37.5334C322.091 35.6148 322 33.6763 322 32C322 30.3237 322.091 28.3852 322.22 26.4666Z"
      fill="white"
      fillOpacity="0.1"
      onClick={onClick}
      className="cursor-pointer"
    />
    <rect
      x="330.5"
      y="26.584"
      width="15"
      height="10.8333"
      rx="2"
      stroke="white"
      strokeWidth="1.5"
      onClick={onClick}
      className="cursor-pointer"
    />
    <path
      className="cursor-pointer"
      d="M332.375 29.8125L342.688 29.8125"
      stroke="white"
      strokeLinecap="round"
      onClick={onClick}
    />
    <path
      className="cursor-pointer"
      d="M332.375 34.5L342.687 34.5"
      stroke="white"
      strokeLinecap="round"
      onClick={onClick}
    />
    <path
      className="cursor-pointer"
      d="M332.375 31.6875L338 31.6875"
      stroke="white"
      strokeLinecap="round"
      onClick={onClick}
    />
  </>
);
FlipButton.propTypes = {
  onClick: PropTypes.func,
};
export default FlipButton;
